module.exports = __webpack_public_path__ + "assets/img/pinpai-cp4.cc0b6af9.png";